import React from 'react'
import styled from 'styled-components'
import { DashboardGrid } from '../../../Shared/ChartComponents'
import { CallsReport } from './CallsReport'
import { Classification } from './Classification'
import { LeadsReport } from './LeadsReport'
import { PendingTask } from './PendingTask'
import { RevenueGraph } from './RevenueGraph'
import { RaceBoard } from './RaceBoard'
import { decryptData } from '../../../services/crypto'
import { canViewRaceBoard } from '../../../Shared/tokens'

export const DashboardSecond = ({staff, setStaff}) => {
  // Get user role for conditional rendering
  let role = null;
  let storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  // Check if user is ceo or admin
  const isAuthorized = role === "ceo" || role === "admin";

  return (
    <Main>
      {/* Oversight view: ceo, admin and v3 only. Placed above revenue because
          it is the "what is happening right now" panel, while revenue is the
          trailing result. */}
      {canViewRaceBoard(role) && (
        <FullWidthSection>
          <RaceBoard />
        </FullWidthSection>
      )}

      {isAuthorized && (
        /* CEO/Admin Exclusive Components */
        <FullWidthSection>
          <RevenueGraph staff={staff}/>
        </FullWidthSection>
      )}

      {/* Standard Dashboard Components */}
      <DashboardGrid>
        <LeadsReport staff={staff}/>
        <PendingTask staff={staff}/>
        <CallsReport staff={staff}/>
        <Classification staff={staff}/>
      </DashboardGrid>
    </Main>
  )
}

const Main = styled.div`
  width: 100%;
  background: transparent;
  padding: 2rem;
  margin-bottom: 2rem;
`

const FullWidthSection = styled.div`
  width: 100%;
  margin-bottom: 2rem;
  
  /* Override the chart container to be full width */
  & > div {
    max-width: none !important;
    width: 100% !important;
  }
`